import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';
import { stepperPreset } from './components/stepperPreset';
import { radioButtonPreset } from './components/radioButtonPreset';
import { inputPreset } from './components/inputPreset';
import { selectPreset } from './components/selectPreset';
import { datePickerPreset } from './components/datePickerPreset';
import { tooltipPreset } from './components/tooltipPreset';
import { buttonPreset } from './components/buttonPreset';
import { iconFieldPreset } from './components/iconFieldPreset';
import { tabsPreset } from './components/tabsPreset';
import { checkboxPreset } from './components/checkboxPreset';
import { fileUploadPreset } from './components/fileUploadPreset';
import { progressBarPreset } from './components/progressBarPreset';
import { dataTablePreset } from './components/dataTablePreset';
import { tagPreset } from './components/tagPreset';
import { paginatorPreset } from './components/paginatorPreset';
import { multiSelectPreset } from './components/multiSelectPreset';

const Preset = definePreset(Aura, {
  components: {
    ...stepperPreset,
    ...radioButtonPreset,
    ...inputPreset,
    ...selectPreset,
    ...multiSelectPreset,
    ...datePickerPreset,
    ...tooltipPreset,
    ...buttonPreset,
    ...iconFieldPreset,
    ...tabsPreset,
    ...checkboxPreset,
    ...fileUploadPreset,
    ...progressBarPreset,
    ...dataTablePreset,
    ...tagPreset,
    ...paginatorPreset,
  },
});

export default Preset;
